import { useEffect, useState } from "react";
import { format, subDays, subYears } from "date-fns";
import dataProvider from "data/dataProvider";
import {
  SHORT_MONTH_DATE,
  YEAR_MONTH_DAY_FORMAT,
} from "features/Common/modules/DateTime/DateTime.constants";
import { DAYS_RANGE } from "ui/pages/marketing/affiliates/affiliates.constants";
import { apiMethods } from "data/api.constants";
import { sales_pages_apis } from "ui/pages/SalesPages/API";
import { date_range_select_options } from "../../constants";
import { isRequestSuccessful } from "utils/Utils";

export const useSalesPageStats = () => {
  const [performanceData, setPerformanceData] = useState("");
  const [selectedRange, onRangeChange] = useState(
    date_range_select_options.last_7.value
  );
  const [dataRange, setDateRange] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getDataRange = () => {
    const today = new Date();
    if (selectedRange === date_range_select_options.custom.value) {
      setStartDate("");
      setEndDate("");
      return "";
    }
    if (selectedRange === date_range_select_options.last_7.value) {
      const startRange = subDays(today, DAYS_RANGE.six);
      setStartDate(format(startRange, YEAR_MONTH_DAY_FORMAT));
      setEndDate(format(today, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        startRange,
        SHORT_MONTH_DATE
      )}`;
    } else if (selectedRange === date_range_select_options.last_30.value) {
      const startRange = subDays(today, DAYS_RANGE.twentyNine);
      setStartDate(format(startRange, YEAR_MONTH_DAY_FORMAT));
      setEndDate(format(today, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        startRange,
        SHORT_MONTH_DATE
      )}`;
    } else if (selectedRange === date_range_select_options.lifetime.value) {
      const startRange = subYears(today, DAYS_RANGE.one);
      setStartDate(format(startRange, YEAR_MONTH_DAY_FORMAT));
      setEndDate(format(today, YEAR_MONTH_DAY_FORMAT));
      return `${format(today, SHORT_MONTH_DATE)} - ${format(
        startRange,
        SHORT_MONTH_DATE
      )}`;
    }
    return "";
  };

  useEffect(() => {
    if (selectedRange !== date_range_select_options.custom.value) {
      setDateRange(getDataRange());
    }
  }, [selectedRange]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    (async () => {
      setPerformanceData("");
      try {
        const statisticsData = await dataProvider.custom_request(
          sales_pages_apis.get_sales_page_stats,
          apiMethods.GET,
          { start_date: startDate, end_date: endDate }
        );

        if (isRequestSuccessful(statisticsData.status)) {
          setPerformanceData(statisticsData.data);
        }
      } catch (err) {
        console.error("Failed to fetch sales page stats", err);
      }
    })();
  }, [startDate, endDate]);

  return {
    performanceData,
    selectedRange,
    onRangeChange,
    dataRange,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };
};
